import { Chip } from '@mui/material';
import { H5, Body3 } from '../../themes/typography';

function TagsSection({ subcategories = [], formats = [], tags = [] }) {
    return (
        <div className="event-preview-tags-section">
            <H5 fontWeight={700}>Tags</H5>

            <div className="event-preview-tags-container">
                {subcategories?.length > 0 &&
                    subcategories?.map((subcategory) => (
                        <CustomChip key={subcategory.id} label={subcategory?.name} />
                    ))}

                {formats?.length > 0 &&
                    formats?.map((format) => <CustomChip key={format.id} label={format?.name} />)}

                {tags?.length > 0 &&
                    tags?.map((tag) => <CustomChip key={tag.id} label={`#${tag?.name}`} />)}
            </div>
        </div>
    );
}

export default TagsSection;

function CustomChip({ label = 'Travel' }) {
    return (
        <Chip
            label={
                <Body3 fontWeight={500} color="var(--tertiary-color)">
                    {label}
                </Body3>
            }
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: 'center',
                border: '1px solid var(--quaternary-color)',
                padding: '0px 14px',
                minHeight: '24px',
                maxHeight: '44px',
                borderRadius: '1.5rem',
                boxSizing: 'border-box',
                textTransform: 'capitalize',
                backgroundColor: 'transparent',
                '& .MuiChip-label': {
                    padding: '0px'
                }
            }}
        />
    );
}
